export default {
  elevation1: '0px 2px 4px -2px #1018281a, 0px 4px 6px -1px #1018281a',
};
